import styled from 'styled-components';
import { FONTS } from '@stelecom/ui-react/assets/js/constants';
import StyledButton from '@stelecom/ui-react/components/buttons/styledButton';
import { COLORS } from '@stelecom/ui-react/assets/js/constants';

export const PopupTitle = styled.div`
  color: ${COLORS.blueDark};
  font-weight: 700;
  font-size: 25px;
  line-height: 35px;
    margin-bottom: 20px;
    width: 100%;
    @media (max-width: 550px) {
        ${FONTS.H3};
    }
`;
export const PopupContent = styled.div`
  width: 1000px;
  padding: 40px 40px 53px 40px;
    flex-direction: column;
  & input{
    max-width: 430px;
  }
    @media (max-width: 700px) {
        width: 500px;
        padding: 40px;
    }
    @media (max-width: 550px) {
        width: 350px;
        padding: 40px;
    }
    @media (max-width: 420px) {
        width: 300px;
        padding: 30px;
    }
  
`;
export const PopupButton = styled(StyledButton)`
    width: 200px;
    @media (max-width: 550px) {
        width: 100%;
    }
`;
export const PopupText = styled.div`
    ${FONTS.S};
    width: 100%;
    margin-bottom: 25px;
`;
